import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { useSelectTheme } from "../../store";
import { t } from "../../engine";
import { Adherence, DigestDay } from "../../model";
import { AdherenceType } from "..";
import { useParams } from "react-router-dom";

export interface AdherenceTableDateHeaderItemContextType {
  adherenceType: string | undefined;
  // datePickerIndex: number
  // setDatePickerIndex: Dispatch<SetStateAction<number>>
  digestDayColumnWidth: number;
  showRightBorder: boolean;
  digestList: DigestDay[];
}

export const AdherenceTableDateHeaderItemContext = createContext<
  AdherenceTableDateHeaderItemContextType | undefined
>(undefined);

export const AdherenceTableDateHeaderItem = (props: { index: number; datePickerIndex: number }) => {
  const adherenceTableDateHeaderItemContext = useContext(AdherenceTableDateHeaderItemContext);
  const { color, fontWeight, fontSize } = useSelectTheme();

  if (!adherenceTableDateHeaderItemContext) {
    return <></>;
  }

  const { adherenceType, digestDayColumnWidth, showRightBorder, digestList } =
    adherenceTableDateHeaderItemContext;
  const { index, datePickerIndex } = props;

  // const {adherenceType} = useParams()

  return (
    <>
      {adherenceType === AdherenceType.Overview && (
        <div
          key={t.uuid()}
          css={{
            boxSizing: "border-box",
            borderRight:
              index !== digestList.length - 1 || showRightBorder
                ? `1px solid ${color.grey_100}`
                : "none",
            borderBottom: `2px solid ${color.border.light}`,
            minWidth: digestDayColumnWidth,
            width: digestDayColumnWidth,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: color.surface.white,
            cursor: "auto",
            padding: "10px 24px",
            minHeight: "56px",
            height: "56px",
          }}
        >
          <div
            css={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "nowrap",
              color:
                index === digestList.length - datePickerIndex - 1
                  ? color.textIcon.link
                  : color.textIcon.secondary,
              fontWeight:
                index === digestList.length - datePickerIndex - 1
                  ? fontWeight.bold
                  : fontWeight.medium,
            }}
          >
            {t.formatIsoToPrettyDate(digestList[index].dayDate)}
          </div>
        </div>
      )}
      {adherenceType !== AdherenceType.Overview && (
        <div
          css={{
            width: 40,
            minWidth: 40,
            borderRight:
              index !== digestList.length - 1 || showRightBorder
                ? `1px solid ${color.grey_100}`
                : "none",
            borderBottom: `2px solid ${color.grey_100}`,
            padding: 10,
            display: "inline-flex",
            alignItems: "center",
            flexDirection: "column",
            backgroundColor: index % 2 === 0 ? color.surface.default : color.surface.white,
            color:
              index === digestList.length - datePickerIndex - 1
                ? color.textIcon.link
                : color.textIcon.secondary,
            fontSize: fontSize.h7,
            textAlign: "center",
            minHeight: "56px",
            height: "56px",
          }}
        >
          {t.formatIsoToPrettyDate(digestList[index].dayDate, true)}
        </div>
      )}
    </>
  );
};
